// ─────────────────────────────────────────────────────────────────
// Sehat AI — QuickSymptoms Component
// Tap-to-send symptom shortcut buttons shown before first message
// ─────────────────────────────────────────────────────────────────

import React from 'react';
import { QUICK_SYMPTOMS } from '../data/specialties';

export default function QuickSymptoms({ onSelect }) {
  return (
    <div style={{ marginBottom: 20 }}>
      <div style={{ textAlign: 'center', fontSize: 11, color: '#9CA3AF', fontWeight: 700, letterSpacing: 0.5, textTransform: 'uppercase', marginBottom: 10 }}>
        Apni takleef chunein / Choose a concern
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, justifyContent: 'center' }}>
        {QUICK_SYMPTOMS.map((q, i) => (
          <button
            key={i}
            onClick={() => onSelect(q.msg)}
            style={{
              padding: '9px 15px', borderRadius: 24,
              border: '1.5px solid #FFD8CC', background: '#fff',
              color: '#374151', fontSize: 12.5, cursor: 'pointer',
              fontFamily: "'Nunito',sans-serif", fontWeight: 700,
              boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
              display: 'flex', alignItems: 'center', gap: 7,
              transition: 'all 0.15s',
            }}
          >
            <span style={{ fontSize: 17 }}>{q.icon}</span>
            {q.label}
          </button>
        ))}
      </div>
    </div>
  );
}
